module.exports = "<p ng-repeat=\"doc in $ctrl.data\">\r\n    <a style=\"float:right; margin-left: 8px\" target=\"_blank\" ng-href=\"/api/storage/{{doc.document}}\"\r\n       class=\"btn btn-sm btn-more\" analytics-on=\"click\"\r\n       analytics-value=\"{{doc._id}}\" analytics-label=\"Download\"\r\n       analytics-category=\"Document Download\" analytics-event=\"{{doc.title}}\">\r\n        <i class=\"fa fa-arrow-circle-right\"></i> more</a>\r\n    <b>{{doc.title}}</b><br/><em>{{doc.description}}</em>\r\n</p>"


//////////////////
// WEBPACK FOOTER
// ./client/components/sidebar/documents-widget/documents-widget.component.html
// module id = 599
// module chunks = 0